import { render, staticRenderFns } from "./TheDialogScaffold.vue?vue&type=template&id=7bc870de"
import script from "./TheDialogScaffold.vue?vue&type=script&lang=js"
export * from "./TheDialogScaffold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports